import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { getNewExamUser } from "../../redux/apiRequest";
import { createAxios } from '../../createInstance';
import { loginSuccess } from '../../redux/authSlice';

import styles from './Home.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

function Home() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.login?.currentUser);
    const axiosJWT = useMemo(() => createAxios(user, dispatch, loginSuccess), [user, dispatch]);

    const newExamState = useSelector((state) => state.exams.newexams);
    // const hisExamState = useSelector((state) => state.exams.historyexams);

    const newExamsList = useMemo(() => {
        if (!Array.isArray(newExamState?.examlists)) return [];
        return newExamState.examlists.map((exam) => ({
            ...exam
        }));
    }, [newExamState]);

    // const hisExamsList = useMemo(() => {
    //     if (!Array.isArray(hisExamState?.examlists)) return [];
    //     return hisExamState.examlists.map((exam) => ({
    //         ...exam
    //     }));
    // }, [hisExamState]);

    // const handleSuccess = async () => {
    //     showToast({
    //         type: "success",
    //         title: "Thành công!",
    //         message: "Xóa chuyên đề thành công.",
    //         duration: 3000
    //     })
    //     getAllSubjectByAllCategory(user.accessToken, dispatch, axiosJWT);
    // };

    // const handleError = () => {
    //     showToast({
    //         type: "error",
    //         title: "Thất bại!",
    //         message: "Vui lòng thử lại sau.",
    //         duration: 3000
    //     })
    // };


    useEffect(() => {
        if (user?.accessToken) {
            getNewExamUser(user.accessToken, dispatch, axiosJWT, user._id);
            // getHisExamUser(user.accessToken, dispatch, axiosJWT, user._id);
        }
    }, [user?.accessToken, dispatch, axiosJWT]);

    const handleNavigateSubject = useCallback((examId) => {
        navigate(`/doexam/${examId}`);
    }, [navigate]);

    return (
        <div className={cx('home')}>
            <div className={cx('category')}>
                <div className={cx('category-header')}>
                    <div className={cx('category-name')}>Bài thi mới</div>
                </div>
                <div className={cx('subject-list')}>
                    {newExamsList.length === 0 ? (
                        <div className={cx('empty-state')}>
                            Hiện tại không có bài thi nào
                        </div>
                    ) : (
                        newExamsList.map((exam) => (
                            <div
                                key={exam.id}
                                className={cx('subject-card')}
                            >
                                <span className={cx('subject-name')}>{exam.title}</span>
                                <div className={cx('subject-actions')}>
                                    <button
                                        type="button"
                                        className={cx('subject-action', 'subject-action--edit')}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            handleNavigateSubject(exam.id)
                                        }}
                                    >
                                        Vào thi
                                    </button>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>

            {/* <div className={cx('category')}>
                <div className={cx('category-header')}>
                    <div className={cx('category-name')}>Lịch sử làm bài thi</div>
                </div>
                <div className={cx('subject-list')}>
                    {hisExamsList.length === 0 ? (
                        <div className={cx('empty-state')}>
                            Hiện tại không có lịch sử làm bài thi nào
                        </div>
                    ) : (
                        hisExamsList.map((exam) => (
                            <div
                                key={exam.id}
                                className={cx('subject-card')}
                                onClick={() => handleNavigateSubject(exam.id)}
                            >
                                <span className={cx('subject-name')}>{exam.title}</span>
                                <div className={cx('subject-actions')}>
                                    <button
                                        type="button"
                                        className={cx('subject-action', 'subject-action--edit')}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            // Vào thi
                                        }}
                                    >
                                        Xem
                                    </button>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div> */}

        </div >
    );
}

export default Home;
